@if (isOpen) {
  <div class="modal-backdrop" (click)="onBackdropClick($event)">

    <div class="modal-container" [class]="modalSizeClass">

      <div class="modal-header">
        <h2 class="modal-title">{{ title }}</h2>
        @if (showCloseButton) {
          <button
            type="button"
            class="modal-close-button"
            (click)="closeModal()"
            aria-label="Cerrar modal">
            <svg class="close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        }
      </div>

      <div class="modal-body">
        @if (content) {
          <div [innerHTML]="content"></div>
        }

        <ng-content></ng-content>
      </div>

      @if (buttons.length > 0 || showCancelButton) {
        <div class="modal-footer">
          @if (showCancelButton) {
            @for (button of buttons; track button.action) {
            <button
              type="button"
              [class]="getButtonClassCancel(button)"
              (click)="onCancelClick()">
              {{ cancelButtonText }}
            </button>
            }
          }

          @for (button of buttons; track button.action) {
            <button
              type="button"
              [class]="getButtonClass(button)"
              [disabled]="button.disabled || button.loading"
              (click)="onButtonClick(button)">

              @if (button.loading) {
                <span class="button-spinner">
            <svg class="spinner" viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-dasharray="32" stroke-dashoffset="32">
                <animate attributeName="stroke-dasharray" dur="2s" values="0 32;16 16;0 32;0 32" repeatCount="indefinite"/>
                <animate attributeName="stroke-dashoffset" dur="2s" values="0;-16;-32;-32" repeatCount="indefinite"/>
              </circle>
            </svg>
          </span>
              }
              <span>{{ button.text }}</span>
            </button>
          }
        </div>
      }
    </div>
  </div>
}
